module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAABGdBTUEAALGPC/xhBQAAAGxJREFUOBFjYCASHD16dCsIE6mcgYVYhf////ciVi1IHRMpiklRO2owPLRGg4L2QcEIyk2kJn64s3AwGBkZt9Eq8v7jsBNT+MiRI/9BGFMGuwitXDxaViDCezSM4WFBs6Agus4DZVOgc4jOIACVzxnMhRE6EgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic_add_to.png
// module id = 1462
// module chunks = 180